export class Customer {
    id: number;
    erpId: number;
    code: string;
    name: string;
    description: string;
    isLocal: boolean;
    distanceToCustomer: number;
    email: string;
    phone: string;
    objectTypeId: number;
    createdDate: Date;
    createdBy: string;
    updatedDate: Date;
    updatedBy: string;
    hourlyRate: number;
    nip: string;
    street: string;
    postCode: string;
    city: string;
    country: string;
    accessParameters: string;
    rules: boolean;
    vstsProjectId: number;
    erpVstsProjectId: number;
    archival: boolean;
    isBlocked: boolean;
    blockedBy: string;
    blockedDate: string;

    employees: CustomerEmployee[];
    systemVersions: CustomerSystemVersion[];
    customerWatchers: CustomerWatcher[];
    licenses: License[];
}

export class CustomerEmployee {
    id: number;
    customerId: number;
    employeeId: number;
    employeeFullName: string;
    email: string;
    phone: string;
    customerName: string;
    customerCode: string;
    customerTin: string;
    customerEmail: string;
    customerPhone: string;
}

export class CustomerSystemVersion {
    id: number;
    customerId: number;
    systemVersionId: number;
    systemVersionName: string;
    isCurrent: boolean;
}

export class CustomerWatcher {
    id: number;
    customerId: number;
    employeeId: number;
    employeeFullName: string;
}

export class CustomerRow {
    id: number;
    code: string;
    name: string;
    nip: string;
    hourlyRate: number;
    distanceToCustomer: number;
    email: string;
    phone: string;
    address: string;
    rules: boolean;
    isBlocked: boolean;
    createdDate: Date;
    createdBy: string;
    updatedDate: Date;
    updatedBy: string;
}

export class License {
    id: number;
    customerId: number;
    appName: string;
    startDate: Date;
    expirationDate: Date;
    checkFrequency: number;
    lastCheckDate: Date;
}